(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["mc-card-mockup"] && !Shopify.designMode) return;
  try {
    (function () {
  function esc(s) { return (s || '').replace(/"/g, '&quot;'); }

  function decodeAttr(s) {
    var t = document.createElement('textarea');
    t.innerHTML = s;
    return t.value;
  }

  function compositeHTML(slide, alt) {
    var h = '<div class="mc-cmp"><img class="mc-bg" src="' + slide.src + '" alt="' + esc(alt) + '" loading="lazy">';
    slide.slots.forEach(function (sl, i) {
      var src = slide.imgs[i];
      if (!src) return;
      h += '<img class="mc-art" src="' + src + '" alt="' + esc(alt) + '" loading="lazy" style="left:' + sl[0] + '%;top:' + sl[1] + '%;width:' + sl[2] + '%;height:' + sl[3] + '%">';
    });
    return h + '</div>';
  }

  function buildCards() {
    var tplCfg = window.MC_CARD_TPLS;
    if (!tplCfg) return;
    document.querySelectorAll('.mc-card-slot:not([data-built])').forEach(function (el) {
      el.setAttribute('data-built', '1');
      var g   = el.getAttribute('data-group') || 'vertical';
      var alt = el.getAttribute('data-alt')   || '';
      var art = [];
      try {
        var raw = decodeAttr(el.getAttribute('data-art') || '[]');
        art = JSON.parse(raw);
      } catch (e) {}
      var tpls   = tplCfg[g] || tplCfg['vertical'] || [];
      var n      = art.length;
      var slides = [];
      var si     = 0;
      tpls.slice(0, 2).forEach(function (t) {
        var imgs = [];
        if (t.slots.length > 1) {
          for (var i = 0; i < t.slots.length; i++) imgs.push(art[i] || art[art.length - 1]);
        } else {
          imgs.push(n <= 1 ? art[0] : (art[si] || art[art.length - 1]));
          si++;
        }
        slides.push({ src: t.src, slots: t.slots, imgs: imgs });
      });
      if (!slides.length) return;
      var html = slides.map(function (s, idx) {
        return '<div class="mc-cs mc-cs-' + (idx + 1) + '">' + compositeHTML(s, alt) + '</div>';
      }).join('');
      el.innerHTML = '<div class="mc-cw">' + html + '</div>';
    });
  }

  if (document.readyState !== 'loading') buildCards();
  else document.addEventListener('DOMContentLoaded', buildCards);
})();
  } catch(e) { console.error(e); }
})();

})();
